export const UPLOAD_CHUNK_SIZE = 1000000;
